import * as React from 'react';
import ReactDropzone, { ImageFile } from 'react-dropzone';
import FileImage from 'src/modules/commons/images/FileImage.component';

interface LegalDocumentationFormComponentProps {
  handleChange: (key: string) => (value: string | File | boolean) => void;
  cifDocument?: File;
  cifDocumentName?: string;
  deedCompany?: File;
  deedCompanyName?: string;
  companyStatutes?: File;
  companyStatutesName?: string;
  realOwnership?: File;
  realOwnershipName?: string;
  idRepresentatives?: File;
  idRepresentativesName?: string;
  notarialDeed?: File;
  notarialDeedName?: string;
}

class LegalDocumentationFormComponent extends React.Component<LegalDocumentationFormComponentProps> {

  public render(): React.ReactNode {
    return (
      <section>
        <div
          className="accordion-toggle question-toggle collapsed pointer"
          data-toggle="collapse"
          data-parent="#faqAccordion"
          data-target="#question455"
        >
          <div className="icon-title">
            <img
              alt="Euro"
              className="icon"
              src="/img/edit-dropdown.png"
            />
            <h4 className="inline-block f-s-18">
              <strong>
                Documentación legal de la empresa
              </strong>
              <span className="d-arrow-up"/>
            </h4>
            <div className="gap-20"/>
          </div>
        </div>
        <div
          id="question455"
          className="collapse"
        >
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('cifDocument')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*, application/pdf"
              >
                <FileImage
                  alt="Doc.CIF"
                  image={this.props.cifDocument}
                  defaultImagePath={ this.props.cifDocumentName ?
                    '/img/corrected.png' : '/img/business-plan.png'}
                />
                <div className="gap-10"/>
                <p className="text-center">
                  {this.props.cifDocumentName ? this.props.cifDocumentName : 'Documento de identidad de la empresa'}

                </p>
              </ReactDropzone>
              <div className="row padding-10" style={{color: '#9C9B9B'}}>Se aceptan documentos PDF, JPG y PNG</div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('deedCompany')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*, application/pdf"
              >
                <FileImage
                  alt="Doc.Escrituras"
                  image={this.props.deedCompany}
                  defaultImagePath={ this.props.deedCompanyName ?
                    '/img/corrected.png' : '/img/text-plan.png'}
                />
                <div className="gap-10"/>
                <p className="text-center">
                  {this.props.deedCompanyName ? this.props.deedCompanyName : 'Escrituras de la empresa'}

                </p>
              </ReactDropzone>
              <div className="row padding-10" style={{color: '#9C9B9B'}}>Se aceptan documentos PDF, JPG y PNG</div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('companyStatutes')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*, application/pdf"
              >
                <FileImage
                  alt="Doc.Estatutos"
                  image={this.props.companyStatutes}
                  defaultImagePath={ this.props.companyStatutesName ?
                    '/img/corrected.png' : '/img/copy-doc.png'}
                />
                <div className="gap-10"/>
                <p className="text-center">
                  {this.props.companyStatutesName ? this.props.companyStatutesName : 'Estatutos de la empresa'}
                </p>
              </ReactDropzone>
              <div className="row padding-10" style={{color: '#9C9B9B'}}>Se aceptan documentos PDF, JPG y PNG</div>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('realOwnership')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*, application/pdf"
              >
                <FileImage
                  alt="Doc.Titularidad Real"
                  image={this.props.realOwnership}
                  defaultImagePath={ this.props.realOwnershipName ?
                    '/img/corrected.png' : '/img/user-doc.png'}
                />
                <div className="gap-10"/>
                <p className="text-center">
                  {this.props.realOwnershipName ? this.props.realOwnershipName : 'Documento de titularidad real'}
                </p>
              </ReactDropzone>
              <div className="row padding-10" style={{color: '#9C9B9B'}}>Se aceptan documentos PDF, JPG y PNG</div>
              <div className="gap-20"/>
            </div>
            <div className="col-sm-6 col-md-4">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('idRepresentatives')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*, application/pdf"
              >
                <FileImage
                  alt="Doc.NIF Representantes"
                  image={this.props.idRepresentatives}
                  defaultImagePath={ this.props.idRepresentativesName ?
                    '/img/corrected.png' : '/img/picture-doc.png'}
                />
                <div className="gap-10"/>
                <p className="text-center">
                  {this.props.idRepresentativesName ? this.props.idRepresentativesName : 'NIF de los representantes'}
                </p>
              </ReactDropzone>
              <div className="row padding-10" style={{color: '#9C9B9B'}}>Se aceptan documentos PDF, JPG y PNG</div>
              <div className="gap-20"/>
            </div>
          </div>
          <div className="row">
            <p className="text-left padding-10">
              <a
                href="/EXAMPLE_Mangopay_Shareholder_Declaration-ES.docx"
                download="download"
              >
                <button
                  style={{ width: '340px', height: '50px' }}
                  className="btn btn-info"
                >
                  Ver ejemplo de titularidad real
                </button>
              </a>
            </p>
          </div>
          <div className="row">
            <p className="text-left padding-10">
              <a
                href="/Mangopay_Shareholder_Declaration-ES.docx"
                download="download"
              >
                <button
                  style={{ width: '340px', height: '50px' }}
                  className="btn btn-info"
                >
                  Descargar documento de titularidad real
                </button>
              </a>
            </p>
          </div>
          <div className="row">
            <div className="gap-20"/>
            <p className="padding-10">
              <strong>* Si los representantes no son los mismos que están en la escritura de la empresa, también se debe
                adjuntar la escritura notarial.</strong>
            </p>
          </div>
          <div className="row">
            <div className="col-sm-6 col-md-4">
              <ReactDropzone
                className="dropzone text-center pointer"
                onDrop={(files: ImageFile[]) => {
                  if (files[0]) {
                    this.props.handleChange('notarialDeed')(files[0]);
                  }
                }}
                multiple={false}
                accept="image/*, application/pdf"
              >
                <FileImage
                  alt="Doc.Escritura notarial"
                  image={this.props.notarialDeed}
                  defaultImagePath={ this.props.notarialDeedName ?
                    '/img/corrected.png' : '/img/guard-doc.png'}
                />
                <div className="gap-10"/>
                <p className="text-center">
                  {this.props.notarialDeedName ? this.props.notarialDeedName : 'Escritura notarial'}
                </p>
              </ReactDropzone>
              <div className="row padding-10" style={{color: '#9C9B9B'}}>Se aceptan documentos PDF, JPG y PNG</div>
              <div className="gap-20"/>
            </div>
          </div>
        </div>

      </section>
    );
  }
}

export default LegalDocumentationFormComponent;



// WEBPACK FOOTER //
// ./src/modules/my-account/juridical-profile-update/forms/LegalDocumentationForm.component.tsx